import React, { Component } from 'react';
import Select from "react-select";
import { Input } from "reactstrap";
import { Modal, message, Switch } from 'antd';
import axios from "axios";

class ExtraMaterialModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
            extraMaterialOptions: [],
            extraMaterials: []
        };
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.getExtraMaterialTypes();
    }
    handleOk = () => {
        this.createExtraMaterials();
    };
    handleCancel = () => {
        this.props.handleOpenExtraModal(false);
    };
    async getExtraMaterialTypes() {
        try {
            const res = await axios.post(
                `https://backoffice.nadu.xyz/api/material-type/getExtraMaterialTypes/`, {
                extraMaterialsInAppointment: this.props.extraMaterialsInAppointment.map((material) => (material.material_type.id)),
            }
            );
            if (res.data && res.data.length > 0) {
                let formattedExtraMaterialTypes = res.data.map((materialType) => (
                    {
                        label: materialType.name,
                        value: materialType.id
                    }
                ))
                this.setState({ extraMaterialOptions: formattedExtraMaterialTypes })
            }
        } catch (error) {
            console.log(error)
        }
    }
    async createExtraMaterials() {
        this.setState({ confirmLoading: true });
        try {
            const res = await axios.post(
                `https://backoffice.nadu.xyz/api/material/createMaterialsByAppointment/`, {
                materialsArray: this.state.extraMaterials.map((material) => (material.value)),
                appointment_uuid: this.props.appointment_uuid,
            }
            );
            if (res.data && res.data.ok) {
                message.success('Se han creado los materiales');
                this.props.getMaterialsByAppointment(this.props.appointment_uuid)
            }
        } catch (error) {
            message.error('Error al crear los materiales');
            console.log(error)
        }
        this.setState({ confirmLoading: false });
        this.props.handleOpenExtraModal(false);
    }
    render() {
        const { openExtraMaterialsModal } = this.props;
        const { confirmLoading } = this.state;
        return (
            <Modal
                title={"Añadiendo materiales extra a la cita"}
                open={openExtraMaterialsModal}
                okButtonProps={{ disabled: this.state.extraMaterials.length === 0 }}
                onOk={this.handleOk}
                centered={true}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
                <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Seleccionar materiales"
                    name="extraMaterials"
                    isMulti={true}
                    noOptionsMessage={() => "Cargando materiales"}
                    value={this.state.extraMaterials}
                    options={this.state.extraMaterialOptions}
                    onChange={(value) =>
                        this.setState({ extraMaterials: value })
                    }
                />
            </Modal>
        );
    }
}

export default ExtraMaterialModal;



// WEBPACK FOOTER //
// ./src/views/HomeVisits/AddExtraMaterial.jsx